import { NgModule } from '@angular/core';
import { InfoComponent } from './info.component';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { TooltipComponent } from './tooltip/tooltip.component';

@NgModule({
  declarations: [
    InfoComponent,
    TooltipComponent,
    TooltipDirective
  ],
  exports: [
    InfoComponent,
    TooltipDirective
  ],
  entryComponents: [TooltipComponent]
})
export class InfoModule {}
